import React from "react";

export const LogoNameOnly = () => <svg width="193" height="56" viewBox="0 0 193 56" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M151.038 0.202698H139.88V55.4753H151.038V0.202698Z" fill="white"/>
<path d="M119.188 32.4535L91.2425 0.405532H85.6128V55.4753H96.9228V23.6302L124.665 55.4753H130.346V0.202698H119.188V32.4535Z" fill="white"/>
<path d="M42.0453 55.4754H76.2289V44.3702H53.1524V31.2873H76.2289V20.3342H53.1524V11.1559H76.4317V0H42.0453V55.4754Z" fill="white"/>
<path d="M159.051 11.3589H170.006V55.4756H181.113V11.3589H192.068V0.405823H159.051V11.3589Z" fill="white"/>
<path d="M1.36937 11.3588H18.0048L0 49.8468V55.6783H32.2565V44.7759H14.4546L32.2565 6.4908V0.608582H1.36937V11.3588Z" fill="white"/>
</svg>
